import React, { ReactElement, useEffect, useMemo, useState } from 'react';
import { useWatch } from 'react-hook-form';

import { useUpdateDependentForm } from '../../../../../../contexts/UpdateDependentFormProviderGdf';
import { Button } from '../../../../../Button';
import {
  changeCivilStatus,
  changeGender,
  changeParentage,
  changeParentageGDF,
} from '../../../../../../utils/ChangeArrays';
import { GoForwardButton } from '../../../../GoForwardButton';
import { DependentForm } from './DependentForm';
import { useRouteLoaderData } from 'react-router-dom';
import { useBoostedPlanDataStore } from '../../../../../../stores/useBoostedPlanDataStore';
import { usePlanLoadingStore } from '../../../../../../stores/usePlanLoadingStore';
import {
  useDependentIdStore,
  useDependentOpenModalDataStore,
  useDependentValueStore,
} from '../../../../../../stores/useDependentStore';
import { CartIcon } from '../../../../../icons/CartIcon';
import Loading from '../../../../../icons/Loading';
import { useVidaCountStore } from '../../../../../../stores/useQuantidadeVidas';
import { usePlansDataStore } from '../../../../../../stores/usePlansDataStore';
import { Select } from '../../../../../Select';
import { useLoadingStore } from '../../../../../../stores/useLoadingStore';

export function BeneficiaryForm(): ReactElement {
  const data: any = useRouteLoaderData('token-dependente');
  const {
    control,
    watch,
    setValue,
    errors,
    handleSubmit,
    onSubmit,
    trigger,
    register,
  } = useUpdateDependentForm();
  const setBoostedPlanData = useBoostedPlanDataStore(
    state => state.setBoostPlanData,
  );
  const valorDependentes = useDependentValueStore(x => x.setValorTotal);
  const setLoading = usePlanLoadingStore(state => state.setLoading);
  const [hasDependentes, setHasDependentes] = useState(false);
  const setCountVida = useVidaCountStore(x => x.setVidaCount);
  const setId = useDependentIdStore(state => state.setId);
  const planData = useBoostedPlanDataStore(x => x.data);
  const Parentesco = changeParentageGDF(data.listaParentescos);
  const [alterPlano, setAlterPlano] = useState(false);
  const loading = useLoadingStore(state => state.loading);
  const isGdf =
    data.produtoComercial.formasPagamentoIndividual.cd_cod_contrato_s4_e ==
    27855;

  const plano = watch('Associado.plano');
  const Associado = watch('Associado');
  const dependentes = watch('Associado.dependentes');
  const newDependents = useWatch({
    control,
    name: 'dependents',
    defaultValue: [],
  });
  const isFilledDependent = (dependent: any) =>
    Boolean(dependent?.name || dependent?.cpf);
  const filledNewDependents = useMemo(
    () =>
      newDependents
        .map((dependent, index) => ({ dependent, index }))
        .filter(({ dependent }) => isFilledDependent(dependent)),
    [newDependents],
  );
  const hasNewDependentes = filledNewDependents.length > 0;
  const erros = errors;
  const [teste, setTeste] = useState(false);
  const PlanosData = usePlansDataStore(x => x.data);
  const [planoAtual, setPlanoAtual] = useState('');

  const Planos = [
    {
      Id: 993,
      Nome: 'OdontoClinico - apenas R$ 0,30 para o Titular',
      Tipo: 'OdontoClinico',
    },
    {
      Id: 998,
      Nome: 'OdontoDoc - apenas R$ 2,90 para o Titular',
      Tipo: 'OdontoDoc',
    },
    {
      Id: 999,
      Nome: 'OdontoProtese - apenas R$ 59,90 para o Titular',
      Tipo: 'OdontoProtese',
    },
    {
      Id: 1000,
      Nome: 'OdontoOrto - apenas R$ 80,00 para o Titular',
      Tipo: 'OdontoOrto',
    },
  ];

  useEffect(() => {
    console.log('Associado gerado: ', watch('Associado'));
    setCountVida(0);
    if (dependentes && dependentes[0]) {
      setHasDependentes(true);
    } else {
      setHasDependentes(false);
    }
    if (PlanosData) {
      console.log('planos retonados: ', PlanosData);
      const findPlan = PlanosData.find(x => x.Id === Number(Associado.plano));
      if (findPlan) {
        setPlanoAtual(findPlan.Nome);
      }
    }
  }, []);

  useEffect(() => {
    valorDependentes(
      hasNewDependentes
        ? calcularDependenteVlTotal(
            filledNewDependents.map(({ dependent }) => dependent),
          )
        : 0,
    );
  }, [filledNewDependents, hasNewDependentes, valorDependentes]);

  const setDependentOpenModal = useDependentOpenModalDataStore(
    x => x.setdependentOpenModalData,
  );

  const fetchPlan = async (planoId, VendedorId) => {
    const urlBaseApiV2 = process.env.REACT_APP_OG_API_URL;
    if (planoId && VendedorId) {
      const plano = planoId == 124 ? 119 : planoId;
      const response = await fetch(`
        ${urlBaseApiV2}/info/dependente/getPlansSeller?vendedor=${VendedorId}&cdS4e=${plano}
        `);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      const urlPlan = process.env.REACT_APP_OG_GET_PLAN_DETAILS_SERVER;
      const Plan = await fetch(`${urlPlan}${data.cd_Codtokenidparc}`);

      const retorno = await Plan.json();
      setBoostedPlanData(retorno);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPlan(plano, data.vendedorId);
  }, [plano]);

  const editClick = (index: number) => {
    setId(index);
    setDependentOpenModal(true);
  };

  function calcularDependenteVlTotal(dependentes: any[]): number {
    return dependentes.reduce((total, dependente) => {
      const valor = parseFloat(
        (String(dependente.plano_vl) || '0').replace(',', '.'),
      );
      return total + (isNaN(valor) ? 0 : valor);
    }, 0);
  }

  const removeClick = (ind: number) => {
    const currentDependentes = watch('dependents') || [];
    const updatedDependentes = currentDependentes.filter(
      (_, index) => index !== ind,
    );
    setValue('dependents', updatedDependentes, {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  async function handleValidate() {
    if (!hasNewDependentes && !alterPlano) {
      alert('Deve adicionar pelo menos 1 novo dependente para proseguir!!!!!');
    } else {
      const dependents = filledNewDependents.map(({ dependent }) => dependent);

      setValue('dependents', dependents, {
        shouldDirty: true,
        shouldValidate: false,
      });

      const isValid = await trigger('dependents');

      console.log(dependents);

      if (!isValid) {
        alert('Verifique os dados do dependente antes de continuar.');
        return;
      }

      handleSubmit(onSubmit)();
    }
  }
  const AlterarPlano = () => {
    alert(
      'Ao clicar em alterar o plano, fique ciente de que essa alteração será refletida para os dependentes e o titular o plano escolhido',
    );
    setAlterPlano(true);
  };

  changeGender(data.listaSexos);
  changeCivilStatus(data.listaEstadosCivil);
  changeParentage(data.listaParentescos);

  return (
    <div className="w-full flex flex-col items-center">
      <h2 className="min-[748px]:text-xl text-lg font-semibold text-primary-main mb-4 mt-4">
        Dados do Titular
      </h2>
      <div className="w-full min-[748px]:mt-4 rounded-xl p-2">
        <div className="grid grid-cols-4 gap-6">
          <div className="col-span-2">
            <label>Nome:</label> {Associado.name}
          </div>
          <div className="col-span-1">
            <label>CPF:</label> {Associado.cpf}
          </div>
          <div className="col-span-1">
            <label>Matricula:</label> {Associado.matricula}
          </div>
          <div className="col-span-1"></div>
        </div>
        <div
          className="grid grid-cols-4 gap-6"
          style={{ marginBottom: '15px' }}
        >
          <div className="col-span-2">
            <label>Plano:</label>{' '}
            {planoAtual || planData?.produtoComercial?.nm_prodcomerc || ''}
          </div>
          <div className="col-span-1">
            <label>Secretaria:</label> {Associado.departamento}
          </div>
          {!isGdf && (
            <div className="col-span-1">
              {!alterPlano ? (
                <Button
                  disabled={hasDependentes}
                  type="button"
                  text="Alterar plano"
                  onClick={AlterarPlano}
                />
              ) : (
                <div className="grid min-[748px]:grid-cols-3 gap-8">
                  <div className="min-[748px]:col-span-2">
                    <Select
                      label="Plano"
                      options={[]}
                      optionsFull={PlanosData}
                      placeholder="Plano"
                      errorMessage={errors.Associado?.plano?.message}
                      {...register(`Associado.plano`)}
                    />
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        <h2 className="min-[748px]:text-[2rem] text-2xl font-semibold text-primary-main">
          Dependentes
        </h2>
        {hasDependentes && (
          <div className="w-full min-[748px]:mt-4 rounded-xl p-2">
            <h3 className="min-[748px]:text-[1.5rem] text-2xl font-semibold text-primary-main">
              Existentes
            </h3>
            <table width="98%" style={{ margin: '2%' }}>
              <thead>
                <tr>
                  <th style={{ textAlign: 'center' }}>Nome</th>
                  <th style={{ textAlign: 'center' }}>sexo</th>
                  <th style={{ textAlign: 'center' }}>Parentesco</th>
                  <th style={{ textAlign: 'center' }}>Plano</th>
                </tr>
              </thead>
              <tbody>
                {dependentes?.map((dependente, index) => (
                  <React.Fragment key={index}>
                    <tr>
                      <td style={{ textAlign: 'center' }}>{dependente.name}</td>
                      <td style={{ textAlign: 'center' }}>
                        {dependente.gender == 'F' ? 'Feminino' : 'Masculino'}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {data.listaParentescos.find(
                          x =>
                            x.Id ==
                            (dependente.parentage == 3
                              ? 10
                              : dependente.parentage == 4
                              ? 11
                              : dependente.parentage),
                        )?.Sigla || 'Dependente Titular'}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {Planos.find(x => x.Id == dependente.plano || 993)
                          ?.Tipo || 'OdontoClinico'}
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <div
        className="w-full min-[748px]:mt-4 rounded-xl p-2"
        style={{
          marginTop: '20px',
          display: 'flex',
          flexDirection: 'row',
          gap: '40px',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <h3 className="min-[748px]:text-[1.5rem] text-2xl font-semibold text-primary-main">
          Novos
        </h3>
        <p className="font-normal text-secondary-main mt-1">
          Você pode adicionar quantos dependentes desejar.
        </p>
        <DependentForm isGdf={isGdf} AlteraPlano={alterPlano} />
      </div>
      {hasNewDependentes && (
        <div className="w-full min-[748px]:mt-4 rounded-xl p-2">
          <table width="98%" style={{ margin: '2%' }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'center' }}>Nome</th>
                <th style={{ textAlign: 'center' }}>CPF</th>
                <th style={{ textAlign: 'center' }}>Nascimento</th>
                <th style={{ textAlign: 'center' }}>Parentesco</th>
                <th style={{ textAlign: 'center' }}>Plano</th>
                <th style={{ textAlign: 'center' }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {filledNewDependents.map(({ dependent: dependente, index }) => (
                <React.Fragment key={index}>
                  <tr>
                    <td style={{ textAlign: 'center' }}>{dependente.name}</td>
                    <td style={{ textAlign: 'center' }}>{dependente.cpf}</td>
                    <td style={{ textAlign: 'center' }}>
                      {dependente.birthDate}
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      {Parentesco.find(
                        x => x.Id == Number(dependente.parentage),
                      )?.Sigla || ''}
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      {(() => {
                        let planoId;
                        if (isGdf) {
                          switch (dependente.plano) {
                            case '124':
                              planoId = 993;
                              break;
                            case '252':
                              planoId = 998;
                              break;
                            case '206':
                              planoId = 999;
                              break;
                            case '251':
                              planoId = 1000;
                              break;
                            default:
                              planoId = 993;
                              break;
                          }
                        } else {
                          planoId = dependente.plano;
                        }
                        return PlanosData
                          ? PlanosData.find(x => x.Id == planoId)?.Nome ||
                              'OdontoClinico'
                          : Planos.find(x => x.Id == planoId)?.Tipo ||
                              'OdontoClinico';
                      })()}
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      <button type="button" onClick={() => editClick(index)}>
                        Editar
                      </button>
                      {' / '}
                      <button type="button" onClick={() => removeClick(index)}>
                        Remover
                      </button>
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <GoForwardButton
        disabled={loading}
        addBackButton
        Icon={loading ? Loading : CartIcon}
        desktopText={loading ? '' : 'Concordar com os Termos'}
        mobileText={loading ? '' : 'Concordar com os Termos'}
        onForwardClick={handleValidate}
      />
    </div>
  );
}
